import React, { useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import PasswordField from "../../Components/Commons/Forms/PasswordField";
import SelectField from "../../Components/Commons/Forms/SelectField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUser } from "../../Components/Helpers/API/UserApi/UserApi";
import { validateUser } from "../../Components/Helpers/Utilities/Validations/Validations";
import "./Users.css";

function AddUsers() {
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);
  const [userData, setUserData] = useState({
    username: "",
    password: "",
    confirm_password: "",
    full_name: "",
    role_id: 3,
    role_name: "resident",
  });
  const [isError, setError] = useState({
    username: false,
    password: false,
    confirm: false,
    full_name: false,
    role: false,
  });

const role = [
    {
      key: "0",
      value: "",
      label: "Select",
    },
    {
      key: "1",
      value: "director",
      label: "Director",
    },
    {
      key: "2",
      value: "pcp",
      label: "PCP",
    },
        {
      key: "3",
      value: "specialist",
      label: "Specialist",
    },
    {
      key: "4",
      value: "nurse",
      label: "nurse",
    },
    {
      key: "5",
      value: "resident",
      label: "Resident",
    },
    {
      key: "6",
      value: "laboratory",
      label: "Laboratory",
    },
  ];

  const handleSelectRole = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = role.find(
      (option) => option.value === selectedValue
    );

    if (selectedOption) {
      const { key, value } = selectedOption;
      setUserData({
        ...userData,
        role_id: key,
        role_name: value,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({
      ...userData,
      [name]: value,
    });
  };
  async function addUser() {
    setIsClicked(true);
    if (validateUser(userData, setError) && !isClicked) {
      if (userData.password === userData.confirm_password) {
        const response = await createUser(userData);
        if (response.data) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate("/users");
          }, 1000);
        } else if (response.error) {
          response.error.data.messages.error_messages.forEach((errMsg) => {
            toast.error(errMsg);
          });
        }
      } else {
        toast.error("Password and Confirm Password Not Matched!");
      }
    }
    setIsClicked(false);
  }

  return (
    <div className="App">
      <Sidebar />
      <div className="col p-5 add-customer pt-4">
        <LabelHeader text={"ADD USER"} />
        <div className="add-user-container ml-7 pt-5">
          <div className="row mt-2">
            <div>
              <TextField
                required
                id="full_name"
                type={`inline`}
                formLabel={`Full Name`}
                size={`sm`}
                onChange={handleChange}
                name="full_name"
                isError={isError.full_name}
                errorMessage="Full name is required"
              />
              <SelectField
                required
                type={`inline`}
                formLabel={`Role`}
                name="role"
                value={userData.role_name}
                size={`sm`}
                options={role}
                isError={isError.role}
                onChange={handleSelectRole}
                errorMessage="Role is required"
                disabled={true}
              />
              <TextField
                required
                id="username"
                type={`inline`}
                formLabel={`Username`}
                size={`sm`}
                onChange={handleChange}
                name="username"
                isError={isError.username}
                errorMessage="Username is required"
              />
              <PasswordField
                required
                id="password"
                type={`inline`}
                formLabel={`Password`}
                size={`sm`}
                onChange={handleChange}
                name="password"
                isError={isError.password}
                errorMessage="Password is required"
              />
              <PasswordField
                required
                id="confirm_password"
                type={`inline`}
                formLabel={`Confirm Password`}
                size={`sm`}
                onChange={handleChange}
                name="confirm_password"
                isError={isError.confirm_password}
                errorMessage="Confirm password is required"
              />
            </div>
            <div className="col-sm-6"></div>
          </div>
        </div>
        <div className="row justify-content-end mb-3 mt-5">
          <div className="col-2 patient-manager">
            <BtnSave
              label={"Submit"}
              size={"sm"}
              onClick={() => addUser()}
              isClicked={isClicked}
              disabled={
                !userData ||
                Object.values(userData.username || "").every((value) => value === "") ||
                Object.values(userData.password).every((value) => value === "") ||
                Object.values(userData.confirm_password).every((value) => value === "") ||
                Object.values(userData.full_name).every((value) => value === "") ||
                Object.values(userData.role_name).every((value) => value === "") 
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUsers;
